import { EnvironmentProviders, makeEnvironmentProviders } from '@angular/core';

import { ApplicationVersionService } from './services/application-version.service';

export function provideApplicationVersion(): EnvironmentProviders {
  return makeEnvironmentProviders([ApplicationVersionService]);
}
